export default __webpack_public_path__ + "resources/icons/d321-8487.png";